angular.module("jv.Candidate.Messages.Factory", ['jv'])
    .factory('jvMessagesFactory', ['candidates', '$window', function (candidates, $window) {
        return {
            findUser: function (arr) {
                if (arr) {
                    for (var i = 0; i < arr.length; i++) {
                        if (arr[i].EId === window.jvUser) {
                            return true;
                        }
                    }
                }
                return false;
            },
            isReplyable: function (message) {
                var isReplyable = false;
                if (message.from && message.from.email) {
                    isReplyable |= this.findUser(message.to) && $window.jvUser !== message.from.EId;
                    isReplyable |= this.findUser(message.cc);
                    isReplyable |= this.findUser(message.bcc);
                }
                return isReplyable;
            },
            replyMessage: function (messageObj) {
                this.openFlyout(messageObj);
            },
            openFlyout: function (messageObj) {
                $scope = angular.element('.quickForms').scope();
                var eventData = {
                    flyoutData: messageObj,
                    flyoutType: 'message'
                };
                $scope.$emit('openFlyout', eventData);
            },
            saveMessage: function (form, index, popoutAttachments, applicationId, callBack) {
                var data = '',
                    queryString = { value: '' },
                    temp,
                    sendToAgency = (form.loadAgencyTemplate === 'agency'),
                    bcc = [],
                    cc = [],
                    to = [];
                form.attachmentEids = [];
                if (form.showBCC && form.deliveryMethod !== 'SMS') {
                    angular.forEach(form.bcc, function (recipient, key) {
                        bcc.push(recipient.EId);
                    });
                }
                if (form.showCC && form.deliveryMethod !== 'SMS') {
                    angular.forEach(form.cc, function (recipient, key) {
                        cc.push(recipient.EId);
                    });
                }

                if (!angular.isUndefined(form.subject)) {
                    if (form.subject.length > 150) {
                        return false;
                    }
                }

                form = angular.extend({
                    attachmentEids: []
                }, form);

                var clone_form = angular.copy(form);
                clone_form.cc = cc;
                clone_form.bcc = bcc;
                clone_form.to = to;

                /*This is to escape the special characters */
                var formContent;
                if (form.deliveryMethod === 'SMS') {
                    formContent = encodeURIComponent(form.contentText);
                } else {
                    formContent = encodeURIComponent(form.content);
                }
                var formSubject = encodeURIComponent(form.subject);

                if (((!form.content || !form.subject || form.subject.length > 150) && form.deliveryMethod !== 'SMS') || ((!form.fromPhone || !form.contentText) && form.deliveryMethod === 'SMS')) {
                    return false;
                }

                queryString.value = 'content=' + formContent + '&subject=' + formSubject + '&to=' + form.candidateEId;
                data = data + queryString.value;


                data += '&' + $.param({
                    to: clone_form.to,
                    cc: clone_form.cc,
                    bcc: clone_form.bcc,
                    sendToAgency: sendToAgency
                }, true);
                if (form.sendUser === 'false' && form.deliveryMethod !== 'SMS') {
                    data += '&' + $.param({
                        sendAnonymously: true
                    });
                }
                if (popoutAttachments.length && form.deliveryMethod !== 'SMS') {
                    angular.forEach(popoutAttachments, function (value, key) {
                        if (value.EId) {
                            form.attachmentEids.push(value.EId);
                        }
                    });
                    data += '&attachments=' + form.attachmentEids.join(",");
                }
                /*BE expects locale to be sent to determine language for Email header/footer*/
                if (form && form.template && form.template.locale) {
                    data += '&locale={0}'.format(form.template.locale);
                }
                if (index) {
                    $scope.messages[index].form = false;
                }
                if (form.deliveryMethod === 'SMS') {
                    data += '&canvasOwnerId=' + form.fromPhone.canvasOwnerId;
                    data += '&canvasChannelKey=' + form.fromPhone.canvasChannelKey;
                    candidates.addSms(applicationId, data, function (response) {
                        callBack(response);
                    });
                } else {
                    candidates.addMessage(applicationId, data, function (response) {
                        callBack(response);
                    });
                }
            }
        };
    }]);
